// Canonical lists of category appearance options, shared by the server
// (mutation validation) and the frontend (pickers and rendering). The
// frontend maps icon names to lucide-react components in
// src/categoryAppearance.tsx — keep that registry in sync with this list.

export const categoryColors = [
  "red",
  "orange",
  "amber",
  "emerald",
  "teal",
  "sky",
  "violet",
  "pink",
] as const;

export type CategoryColor = (typeof categoryColors)[number];

export const isCategoryColor = (value: string): value is CategoryColor =>
  (categoryColors as readonly string[]).includes(value);

export const categoryIcons = [
  "baby",
  "badge-dollar-sign",
  "banknote",
  "beer",
  "bike",
  "book-open",
  "briefcase",
  "building",
  "bus",
  "camera",
  "car",
  "car-taxi-front",
  "cat",
  "chef-hat",
  "code",
  "coffee",
  "coins",
  "credit-card",
  "dices",
  "dog",
  "donut",
  "droplets",
  "dumbbell",
  "film",
  "fuel",
  "gamepad-2",
  "gift",
  "graduation-cap",
  "hammer",
  "hand-coins",
  "heart-handshake",
  "heart-pulse",
  "home",
  "lamp",
  "landmark",
  "laptop",
  "martini",
  "music",
  "percent",
  "phone",
  "piano",
  "piggy-bank",
  "pill",
  "pizza",
  "plane",
  "receipt",
  "repeat",
  "scissors",
  "shapes",
  "shirt",
  "shopping-bag",
  "shopping-cart",
  "sofa",
  "spade",
  "sparkles",
  "stethoscope",
  "tag",
  "tennis-ball",
  "tennis-racket",
  "train-front",
  "tram-front",
  "trees",
  "trending-up",
  "tv",
  "umbrella",
  "user-round",
  "users-round",
  "utensils",
  "wifi",
  "wrench",
  "zap",
] as const;

export type CategoryIcon = (typeof categoryIcons)[number];

export const isCategoryIcon = (value: string): value is CategoryIcon =>
  (categoryIcons as readonly string[]).includes(value);
